import { Pipe, PipeTransform, Inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FORMATS_CONFIGURATION_TOKEN, FormatConfiguration } from '../tokens';

@Pipe({
  name: 'currencyCustom'
})
export class CurrencyCustomPipe implements PipeTransform {
  currencies: {
    [id: number]: { id: number; name: string; code: string; symbol?: string };
  };

  constructor(
    @Inject(FORMATS_CONFIGURATION_TOKEN) configuration: FormatConfiguration,
    private cp: CurrencyPipe
  ) {
    this.currencies = configuration.currencies;
  }

  transform(amount: number, currencyId: string): any {
    if (!currencyId) return '-';
    return this.cp.transform(
      +amount,
      this.currencies[`${currencyId}`].code,
      this.currencies[`${currencyId}`].symbol
        ? this.currencies[`${currencyId}`].symbol
        : undefined
    );
  }
}
